import {
    Backdrop, Card, CardContent, CardHeader, CircularProgress,
    Container, Divider, Snackbar, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, IconButton, Button,
    Dialog, DialogTitle, DialogContent, DialogActions,
    Grid, List, ListItem, ListItemIcon, ListItemText,
    Typography

} from '@material-ui/core';
import Alert from 'src/components/Alert';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import Page from 'src/components/Page';
import AttachFileOutlinedIcon from '@material-ui/icons/AttachFileOutlined';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import GamesOutlinedIcon from '@material-ui/icons/GamesOutlined';
import ExtensionIcon from '@material-ui/icons/Extension';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { confirmAlert } from 'react-confirm-alert';
import { useHistory } from 'react-router';
import CloseIcon from '@material-ui/icons/Close';
import Tarihce from 'src/views/History';
import ListItemButton from '@material-ui/core/ListItemAvatar';
import FolderIcon from '@material-ui/icons/Folder';
import ExpandableComment from 'src/components/ExpandableComment';

function OpenReject() {
    const useStyles = makeStyles((theme) => ({
        root: {
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3)
        },
        rootlist: {
            width: '100%',
            backgroundColor: theme.palette.background.paper,
            position: 'relative',
            overflow: 'auto',
            maxHeight: 550,
        },
        rootlistsag: {
            width: '100%',
            backgroundColor: theme.palette.background.paper,
            position: 'relative',
            overflow: 'auto',
            maxHeight: 500,
        },

        cardBolum: {
            maxHeight: 700,
            minHeight: 700,
            width: '100%'
        },
        table: {
            minWidth: 650,
        },
        content: {
            minHeight: 550,
        },
        chatSection: {
            width: '100%',
        },
        container: {
            maxHeight: '100%',
            maxWidth: '100%',
            minWidth: '100%'
        },
        container1: {
            maxHeight: 630,
            maxWidth: '100%',
            minWidth: '100%'
        },
        avatar: {
            cursor: 'pointer',
            width: 40,
            height: 40
        },
        headBG: {
            backgroundColor: '#e0e0e0'
        },
        borderRight500: {
            borderRight: '1px solid #e0e0e0'
        },
        messageArea: {
            overflowY: 'auto'
        },
        button: {
            margin: theme.spacing(1),
        },
        backdrop: {
            zIndex: 1500,
            color: '#fff'
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(0),
            top: theme.spacing(-1),
            color: theme.palette.grey[500],
        },
        formControl: {
            margin: theme.spacing(3)
        },
        cardscontent3: {
            minHeight: 50
        },
        cardscontent2: {
            height: 600
        },
        spanText: {
            lineHeight: 2,
            fontFamily: 'Roboto',
            fontSize: 14
        },
        textInput: {
            border: 'none',
            borderBottom: '1px solid #1890ff',
            padding: '2px 5px',
            outline: 'none',
            fontWeight: 'bold',
        },
        responsiveContainer: {
            [theme.breakpoints.between("md", "lg")]: {
                maxHeight: "70vh",
                overflowX: 'hidden',
                overflowY: 'scroll'
            },
            [theme.breakpoints.down("sm")]: {
                maxHeight: "60vh",
                overflow: 'scroll'
            }
        }
    }));


    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [acilisTipId, setAcilisTipId] = useState(null)
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });
    const [tarihcePopUp, setTarihcePopUp] = useState(false);
    const [filePopUp, setFilePopUp] = useState(false);
    const [fileList, setFileList] = React.useState([])
    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    const [generalData, setGeneralData] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const SessionUser = getUser();
    const history = useHistory();

    useEffect(() => {
        getRejectedOpeningList();
    }, []);


    const getRejectedOpeningList = () => {
        setLoading(true);
        axios.get(`/GetRejectedOpeningList/${SessionUser.TopServiceShopCode}`)
            .then((response) => {
                setLoading(false);
                const res = response.data;
                setGeneralData(res);
            }).catch(error => {
                setLoading(false);
            });
    };
    //Red butonu tıklanınca
    const handleRejectButtonClicked = (id, durum) => {
        confirmAlert({
            message: 'Bu açılış başvurusu reddedilecek ve "BY - Onay" durumuna dönecektir. Onaylıyor musunuz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        cancelOrConfirmBasvuru(id, durum, true);
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => {
                        return;
                    }
                }
            ]
        });

    };

    //İptal butonu tıklanınca    
    const handleCancelButtonClicked = (id, durum) => {
        confirmAlert({
            message: 'Bu açılış başvurusu iptal edilecektir. Onaylıyor musunuz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        cancelOrConfirmBasvuru(id, durum, true);
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => {
                        return;
                    }
                }
            ]
        });
    };

    //Devam et butonu tıklanınca
    const handleConfirmButtonClicked = (id, durum) => {
        confirmAlert({
            message: 'Bu açılış başvurusu sürece tekrardan dahil edilecektir. Onaylıyor musunuz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        cancelOrConfirmBasvuru(id, durum, false);

                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => {
                        return;
                    }
                }
            ]
        });
    };

    const cancelOrConfirmBasvuru = async (id, durum, cevap) => {
        const data = JSON.stringify({
            Id: id,
            Durum: durum,
            IsCancel: cevap,
            UserId: "" //okta
        });

        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        axios.post('CancelOrConfirmBasvuru', data, config).then((response) => {
            var res = response.data[0];
            if (res.ErrorCode == '1000') {
                setresponseMessage(res.ErrorDescription)
                setUyariTip("error");
                setUyari(true);
                setLoading(false);
            }
            if (res.ErrorCode == '0') {
                setresponseMessage(res.ErrorDescription)
                setUyariTip("success");
                setUyari(true);
                setLoading(false);
                getRejectedOpeningList();
                if (!cevap) {
                    history.push(`/confirm?id=${id}`);
                }
            }
        }).catch(error => {
            setLoading(false);
        });
    };
    const handleYorum = (row) => {
        setSelectedIndex(row.ID);
        setTarihcePopUp(true);
    };

    const handleFilePopUp = (row) => {
        setSelectedIndex(row.ID);
        getReceiptAllFiles(row.ID)
        setFilePopUp(true);
    };

    const getReceiptAllFiles = (receiptNumber) => {
        setFileList([]);
        setLoading(true);
        if (!receiptNumber) {
            return;
        }
        var images = []
        axios.get("/getReceiptAllFiles/" + receiptNumber + '/' + 1, {
            responseType: 'arrayBuffer'
        }).then(response => {
            setFileList(response.data)
            setLoading(false)
        });
    }
    const setNewWindowOpen = (item) => {
        //get file data from GetReceiptFilesSpecial api
        setLoading(true);
        axios.get(`/GetReceiptFilesSpecial/${item.DOSYA_ID}`)
            .then((response) => {
                const res = response.data[0];
                var FileData = `data:${res.DOSYA_TIPI};base64,${res.DOSYA_DATA}`
                if (res?.DOSYA_TIPI?.includes('image')) {
                    var image = new Image();
                    image.src = FileData;
                    var w = window.open("");
                    w.document.write(image.outerHTML);
                    w.document.title = res.DOSYA_ADI;
                    w.document.close();
                } else {
                    var blobData = base64ToBlob(res.DOSYA_DATA, "application/pdf");
                    openBlobInNewTab(blobData);
                }
                setLoading(false);
            }).catch(error => {
                setLoading(false);
            });

        // var FileData = `data:${item.DOSYA_TIPI};base64,${item.DOSYA_DATA}`
        // if (item?.DOSYA_TIPI?.includes('image')) {
        //     var image = new Image();
        //     image.src = FileData;
        //     var w = window.open("");
        //     w.document.write(image.outerHTML);
        //     w.document.title = item.DOSYA_ADI;
        //     w.document.close();
        // } else {
        //     var blobData = base64ToBlob(item.DOSYA_DATA, "application/pdf");
        //     openBlobInNewTab(blobData);
        // }
    }

    function base64ToBlob(base64Data, contentType) {
        var byteCharacters = atob(base64Data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
    function openBlobInNewTab(blobData) {
        var newTab = window.open();
        var objectUrl = URL.createObjectURL(blobData);
        newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
    }

    return (
        <Page className={classes.root}>
            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Container className={classes.container1} maxWidth="xl">
                <Card>
                    <CardHeader title="Reddedilenler" />
                    <Divider />
                    <CardContent>
                        <TableContainer >
                            <Table stickyHeader aria-label="sticky table" size="small">
                                <TableHead style={{ overflowWrap: 'break-word' }}>
                                    <TableRow>
                                        <TableCell align="left">Açılış Tipi</TableCell>
                                        <TableCell align="left">Durum</TableCell>
                                        <TableCell align="left">İl-İlçe</TableCell>
                                        <TableCell align="left">Servis Tipi</TableCell>
                                        <TableCell align="left">Servis Bilgi</TableCell>
                                        <TableCell align="left">Açılış Detayı</TableCell>
                                        <TableCell align="left">Servis Konumu</TableCell>
                                        <TableCell align="left">Findeks Yorumu</TableCell>
                                        <TableCell align="left">Yorumlar</TableCell>
                                        <TableCell align="left">Belgeler</TableCell>
                                        <TableCell align="center" colSpan={2}>Süreç İşlemi</TableCell>
                                        <TableCell align="left" />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {generalData?.length ? generalData.map((row, index) => (
                                        <TableRow key={index}
                                            style={row.ID === selectedIndex ? { backgroundColor: "#FF9800" }
                                                : {}}
                                        >
                                            <TableCell align="left">{row.ACILIS_TIP}</TableCell>
                                            <TableCell align="left">{row.DURUM_ID == 1 ? row.DURUM : row.SONRAKI_ADIM_ACIKLAMA}</TableCell>
                                            <TableCell align="left">{row.IL_ILCE}</TableCell>
                                            <TableCell align="left">{row.SERVIS_TIP}</TableCell>
                                            <TableCell align="left">
                                                <ExpandableComment
                                                    Comment={row.SERVIS_BILGI}
                                                    CommentLimit={100}
                                                    DarkColor={selectedIndex != row.ID ? false : true} />
                                            </TableCell>
                                            <TableCell align="left">{row.ACILIS_TIP_ID == 1 ? '-' :
                                                row.ACILIS_TIP_ID == 2 ? <><b>Devir olan servis: </b> {row.DEVIR}</> :
                                                    row.ACILIS_TIP_ID == 3 ? <><b>Şirketleşen servis: </b> {row.SIRKETLESME}</> :
                                                        row.ACILIS_TIP_ID == 4 ? <><b>Birleşen servisler: </b> {row.BIRLESME}</> :
                                                            <><b>Şube Açan Servis: </b> {row.SUBELESME}</>}</TableCell>
                                            <TableCell align="left">{row.SERVIS_KONUMU}</TableCell>
                                            <TableCell align="left">{row.FINDEKS_YORUM}</TableCell>
                                            <TableCell align="left">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleYorum(row)}
                                                    style={{ backgroundColor: '#19ecff', color: 'white' }}
                                                >
                                                    <CommentOutlinedIcon />
                                                </IconButton>
                                            </TableCell>
                                            <TableCell align="left">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleFilePopUp(row)}
                                                    style={{ backgroundColor: '#FF7F00', color: 'white' }}
                                                >
                                                    <AttachFileOutlinedIcon />
                                                </IconButton>
                                            </TableCell>

                                            <TableCell align="left" colSpan={2}>
                                                {row.DURUM_ID == 1 ?
                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <Button
                                                            color="secondary"
                                                            onClick={() => handleCancelButtonClicked(row.ID, row.DURUM_ID)}
                                                            aria-label="close"
                                                            variant="contained"
                                                            endIcon={<BlockIcon />}
                                                            style={{ backgroundColor: '#ff0000', color: 'white' }}
                                                            fullWidth
                                                        >
                                                            İptal Et

                                                        </Button>
                                                    </div> : row.DURUM_ID == 5 ?
                                                        <div style={{ display: 'flex' }}>
                                                            <Button
                                                                color="secondary"
                                                                onClick={() => handleCancelButtonClicked(row.ID, row.DURUM_ID)}
                                                                aria-label="close"
                                                                variant="contained"
                                                                endIcon={<BlockIcon />}
                                                                style={{ backgroundColor: '#ff0000', color: 'white' }}
                                                                width="100%"
                                                                fullWidth
                                                            >
                                                                İptal Et
                                                            </Button>
                                                            <div style={{ width: '10px' }}></div>
                                                            <Button
                                                                color="secondary"
                                                                onClick={() => handleConfirmButtonClicked(row.ID, row.DURUM_ID)}
                                                                aria-label="save"
                                                                variant="contained"
                                                                style={{ backgroundColor: '#008000', color: 'white' }}
                                                                endIcon={<CheckCircleOutlineIcon />}
                                                                width="100%"
                                                                fullWidth
                                                            >
                                                                Devam Et
                                                            </Button>
                                                        </div> :
                                                        <div style={{ display: 'flex' }}>
                                                            <Button
                                                                color="secondary"
                                                                onClick={() => handleRejectButtonClicked(row.ID, row.DURUM_ID)}
                                                                aria-label="close"
                                                                variant="contained"
                                                                endIcon={<BlockIcon />}
                                                                style={{ backgroundColor: '#ff0000', color: 'white' }}
                                                                width="100%"
                                                                fullWidth
                                                            >
                                                                Reddet
                                                            </Button>
                                                            <div style={{ width: '10px' }}></div>
                                                            <Button
                                                                color="secondary"
                                                                onClick={() => handleConfirmButtonClicked(row.ID, row.DURUM_ID)}
                                                                aria-label="save"
                                                                variant="contained"
                                                                style={{ backgroundColor: '#008000', color: 'white' }}
                                                                endIcon={<CheckCircleOutlineIcon />}
                                                                width="100%"
                                                                fullWidth
                                                            >
                                                                Devam Et
                                                            </Button>
                                                        </div>
                                                }
                                            </TableCell>

                                        </TableRow>
                                    )) : <TableRow />}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                    <Dialog
                        open={tarihcePopUp}
                        fullWidth
                        maxWidth="lg"
                        onClose={event => setTarihcePopUp(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Yorum Geçmişi</DialogTitle>
                        <DialogContent>
                            <Tarihce BasvuruId={selectedIndex} readonly={false} OpenClose={1} />
                        </DialogContent>
                        <DialogActions>
                            <IconButton
                                color="primary"
                                onClick={event => setTarihcePopUp(false)}
                                aria-label="upload picture"
                                component="span"
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={filePopUp}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        maxWidth="md"
                    >
                        <DialogContent>
                            <Grid container spacing={2}>
                                <List>
                                    {fileList?.length ? fileList?.map((item, index) => (
                                        <ListItem key={item.DOSYA_ID}>

                                            <ListItemButton
                                                style={{ display: 'flex', cursor: 'pointer' }}
                                            >
                                                <ListItemIcon>

                                                    <FolderIcon style={{ color: '#424242' }} />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={<Typography type="body2"> {item.DOSYA_ADI}</Typography>}
                                                    onClick={() => {
                                                        setNewWindowOpen(item);
                                                        // setShowFile(true)
                                                        // setSelectedFile(row)
                                                    }}
                                                />
                                                <ListItemText
                                                    primary={item.ContentType}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    )) : !loading ? "Dosya Bulunmamaktadır." : "Dosyalar Yükleniyor..."}
                                </List>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <IconButton
                                color="primary"
                                onClick={() => {
                                    setFilePopUp(false);
                                }}
                                aria-label="close"
                                component="span"
                                variant="contained"
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                </Card>
            </Container>
        </Page>
    );
}
export default OpenReject;
